
const BASE_URL = "https://api.themoviedb.org/3/";
const BACKDROP_BASE_URL = "https://image.tmdb.org/t/p/original/"
const SMALL_IMG_COVER_BASE_URL = "https://image.tmdb.org/t/p/w300"

export { BASE_URL, BACKDROP_BASE_URL, SMALL_IMG_COVER_BASE_URL }